module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-binary-486f618c.svg";